/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_INVOICES, GET_INVOICES } from 'src/actions/invoiceActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INVOICES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_INVOICES: {
      const { invoices, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = invoices;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default invoiceReducer;
